function getLevelName(level) {
  return typeof level === "string" ? level : level?.name;
}

function toValidDate(dateLike) {
  if (!dateLike) return null;
  const parsed = new Date(dateLike);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function getEarliestDate(dates) {
  let earliest = null;
  dates.forEach((candidate) => {
    if (!candidate) return;
    if (!earliest || candidate < earliest) {
      earliest = candidate;
    }
  });
  return earliest;
}

function getHistoryAnchorDate(userData) {
  const historyKeys = [
    "user_status_history",
    "access_levels_history",
    "user_role_history",
    "company_history",
    "user_department_history",
    "user_group_history",
    "user_section_history",
  ];

  const historyDates = historyKeys.flatMap((key) => {
    const history = Array.isArray(userData?.[key]) ? userData[key] : [];
    return history
      .map((entry) => toValidDate(entry?.effective_date || entry?.created_at))
      .filter(Boolean);
  });

  return getEarliestDate(historyDates);
}

export function isAdmsUser(userData) {
  return Boolean(
    userData?.access_levels?.some(
      (level) => getLevelName(level) === "АДМС",
    ),
  );
}

/**
 * Доступ в течение календарного месяца после «начала» в портале:
 * сначала `created_at` (если бэкенд отдаёт), иначе `hire_date` (как в auth/me).
 */
export function isWithinFirstMonthAfterRegistration(userData) {
  const directAnchor = toValidDate(userData?.created_at || userData?.hire_date);
  const historyAnchor = getHistoryAnchorDate(userData);
  const anchor = directAnchor || historyAnchor;
  if (!anchor) return false;

  const firstMonthEnd = new Date(anchor);
  firstMonthEnd.setMonth(firstMonthEnd.getMonth() + 1);
  return new Date() <= firstMonthEnd;
}

/** Блок «Добро пожаловать» и страница материалов адаптации. */
export function canAccessOnboardingWelcome(userData) {
  return isAdmsUser(userData) || isWithinFirstMonthAfterRegistration(userData);
}
